import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col border-2 rounded overflow-hidden" }
const _hoisted_2 = { class: "relative w-full overflow-hidden" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "aspect-square" }, null, -1)
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "absolute px-1 py-0.5 bottom-2 right-2 flex items-center space-x-1 bg-black/60 text-white rounded shadow" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "97", -1)
const _hoisted_7 = {
  key: 1,
  class: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
}
const _hoisted_8 = { class: "flex flex-col w-full divide-y-2 px-4" }
const _hoisted_9 = { class: "py-4" }
const _hoisted_10 = { class: "block truncate text-xs text-black/50" }
const _hoisted_11 = { class: "block truncate font-bold" }
const _hoisted_12 = { class: "flex justify-between items-end w-full space-x-1 py-4" }
const _hoisted_13 = { class: "overflow-hidden" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs block" }, "Price", -1)
const _hoisted_15 = { class: "flex items-center space-x-1 truncate" }
const _hoisted_16 = { class: "block font-bold" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Make offer")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeartIcon = _resolveComponent("HeartIcon")!
  const _component_AppEtherIcon = _resolveComponent("AppEtherIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.preview || _ctx.token.image_preview_url)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("img", {
              class: "absolute inset-0 object-cover w-full h-full",
              src: _ctx.token.image_preview_url,
              alt: _ctx.token.name
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_HeartIcon, {
                class: _normalizeClass(["w-3 h-3 stroke-1", 'fill-rose-600 stroke-rose-600'])
              }),
              _hoisted_6
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "default")
          ]))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString((_ctx.token.creator?.user?.username &&
            "@" + _ctx.token.creator?.user?.username) ||
          "Unknown"), 1),
        _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.token.name || " "), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_AppEtherIcon, { class: "block flex-shrink-0 w-2.5" }),
            _createElementVNode("span", _hoisted_16, _toDisplayString((_ctx.preview && (_ctx.token?.price || "0")) || "0.10"), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_AppButton, {
            rounded: false,
            to: {
              path:
                '/collection/' +
                _ctx.token.asset_contract?.address +
                '/items/' +
                _ctx.token.token_id +
                '/offer',
            },
            color: "white",
            size: "sm",
            dense: ""
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
}